import { axios } from '@/utils/request'
const api = {
  source: '/order/AccessoryOrder',
}
// // 配件订单列表
export function addOrderAccessory (parameter) {
  return axios({
    url: '/order/accessory/updateOrderAccessory',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getAccessoryOrderlist (parameter) {
  return axios({
    url: api.source +'/list',
    method: 'get',
    params: parameter,
  })
}
export function getAccessoryExcept (parameter) {
  return axios({
    url: api.source +'/export',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    }
  })

}
// // 发货
export function getdeliverGoods (parameter) {
  return axios({
    url: '/order/AccessoryOrder/deliverGoods',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 查看库存
export function getAccessoryNumber (parameter) {
  return axios({
    url: '/stock/storageAccessory/getAccessoryNumber',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getselectstore (parameter) {
  return axios({
    url:  '/stock/selectutils/selectstore',
    method: 'get',
    params: parameter,
  })
}
